import { StarDisplay } from "@/components/reviews/StarRating";

export default function RatingSummary({ data, active, onPick, dark = false }) {
  const total = data?.total || 0;
  return (
    <div data-testid="rating-summary" className="flex flex-col sm:flex-row gap-8 sm:items-center">
      <div>
        <div data-testid="rating-average" className="font-display text-6xl leading-none">{total ? data.average.toFixed(1) : "—"}</div>
        <div className="mt-2"><StarDisplay value={data?.average || 0} size={18} dark={dark} /></div>
        <div data-testid="rating-total" className={`text-xs uppercase tracking-widest mt-2 ${dark ? "text-white/60" : "text-muted-foreground"}`}>
          {total} review{total === 1 ? "" : "s"}
        </div>
      </div>
      <div className="flex-1 space-y-1.5 min-w-[220px]">
        {[5, 4, 3, 2, 1].map((s) => {
          const n = data?.counts?.[s] || 0;
          const pct = total ? (n / total) * 100 : 0;
          return (
            <button key={s} type="button" data-testid={`rating-filter-${s}`} disabled={!onPick || !n}
              onClick={() => onPick?.(active === s ? null : s)}
              className={`w-full flex items-center gap-3 text-xs group ${active === s ? "font-bold" : ""} disabled:cursor-default`}>
              <span className="w-8 text-left">{s} ★</span>
              <span className={`flex-1 h-2 rounded-full overflow-hidden ${dark ? "bg-white/15" : "bg-[#1C211E]/10"}`}>
                <span className="block h-full bg-[#C84A31] transition-[width] duration-700" style={{ width: `${pct}%` }} />
              </span>
              <span className="w-8 text-right opacity-70">{n}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
